import { TFunction } from "i18next";
import * as yup from "yup";

export interface EditUserValidationSchemeProps {
  t: TFunction;
}

export const EditUserValidationScheme = ({
  t,
}: EditUserValidationSchemeProps) => {
  const invalidEmailMsg = t("validations.invalidEmail");
  const invalidPhoneNumberMsg = t("validations.invalidPhoneNumber");

  return yup.object().shape({
    email: yup.string().nullable().trim()
      .notRequired()
      .matches(
        /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        invalidEmailMsg),
    phone: yup.string().nullable().trim()
      .notRequired()
      // .matches(/^((([\+]?|00)\d{3}[-\s]?)?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{1,4})$/,
      .matches(/^$|\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/,
        invalidPhoneNumberMsg)
  });
};